import { head, last, map, size, some, tail, uniqBy } from 'lodash-es';
import moment from 'moment';
import { FormattedMessage } from 'react-intl';

import { calculateDuration } from '../../../common/utils/dateUtils';

export function getFlightStops(flights) {
  const uniqFlights = uniqBy(flights, f => f.flightNumber);
  const stopoverAirports = map(tail(uniqFlights), f => f.originAirportCode);
  return stopoverAirports;
}

export function getFlightDuration(flights) {
  const firstFlight = head(flights);
  const lastFlight = last(flights);

  return calculateDuration(
    moment(firstFlight?.departure?.estimated).tz(
      firstFlight?.originAirportTimezone,
      true
    ),
    moment(lastFlight?.arrival?.estimated).tz(
      lastFlight?.destinationAirportTimezone,
      true
    )
  );
}

export const FlightStops = ({ flights }) => {
  const flightStops = getFlightStops(flights);

  if (size(flights) === 1) {
    return <FormattedMessage id="book.newQuote.stopsNone" />;
  }

  if (!some(flightStops))
    return <FormattedMessage id="book.newQuote.directFlight" />;

  return (
    <FormattedMessage
      id="book.newQuote.stopsCount"
      values={{ stopsCount: size(flightStops) }}
    />
  );
};
